import path from 'path';
import i18n, { i18n_t } from '@/locales/i18n';
import { SpaceTag } from '@/renderer/scripts/libs/smh-sdk-class/typings';

export enum CoSyncStrategy {
  LOCAL_TO_CLOUD = 'local_to_cloud',
  CLOUD_TO_LOCAL = 'cloud_to_local',
  BOTH = 'both',
}
export type KeepWhichLastStatus = 'none' | 'started' | 'stopped';

export enum CoSyncTimingType {
  MANUL = 'manul',
  AUTO = 'auto',
  TIMIING = 'timing',
}

export enum ConflictStrategy {
  ASK = 'ask',
  USE_LOCAL = 'use_local',
  USE_REMOTE = 'use_remote',
  KEEP_BOTH = 'keep_both',
}

export interface CoSyncPath {
  localPath: string;
  remotePath: string;
  spaceId: string; // 同步盘所在空间信息
  spaceTag: SpaceTag; // 同步盘所在空间类型
  spaceOrgId: number; // 同步盘所在空间企业id
  teamId: number;
  teamPath: string; // 同步盘所在企业空间的路径名,例如：A团队/B团队/
  isCreateBaseLocal: boolean;
}

export function getRemotePathUserChoose(coSyncPath: CoSyncPath): string {
  if (coSyncPath.isCreateBaseLocal) {
    return path.dirname(coSyncPath.remotePath);
  }

  return coSyncPath.remotePath;
}

export function getLocalPathUserChoose(coSyncPath: CoSyncPath): string {
  if (coSyncPath.isCreateBaseLocal) {
    return coSyncPath.localPath;
  }

  return path.dirname(coSyncPath.localPath);
}

export function getName(coSyncPath: CoSyncPath): string {
  if (coSyncPath.isCreateBaseLocal) {
    return path.basename(coSyncPath.localPath);
  }

  return path.basename(coSyncPath.remotePath);
}

export function GetRemotePathWithSpaceAndTeam(spaceTag: SpaceTag, teamPath: string, remotePath: string): string {
  if (spaceTag !== SpaceTag.personal && spaceTag !== SpaceTag.team) return '';

  if (spaceTag === SpaceTag.personal) {
    const ret = path.posix.join(i18n_t('个人空间'), remotePath);
    return ret;
  }

  const ret = path.posix.join(i18n_t('企业空间'), teamPath, remotePath);
  return ret;
}

export interface CoSyncSetting {
  strategy: CoSyncStrategy; // 同步策略
  timingType: CoSyncTimingType; // 同步类型
  conflictStrategy: ConflictStrategy; // 冲突解决策略
  keepWhichLastStatus: KeepWhichLastStatus; // 保持上一次的什么状态
  ignoreList?: string[]; // 目录级排除清单（仅本地生效、不回传后端、创建后只读）
}

export interface CoSyncTaskConfig {
  syncPath: CoSyncPath;
  syncSetting: CoSyncSetting;
}

export interface CoSyncInfo {
  syncId: number;
  localSyncId: number; // 本地在不同用户，不同企业里的唯一同步盘标识。用于数据库，map查找的唯一标识
  config: CoSyncTaskConfig;
}

export class CoSyncConfig {
  private syncInfoList: Map<number, CoSyncInfo> = new Map<number, CoSyncInfo>();

  private userInfo: CoFile.UserInfo = {};

  setCoSyncInfo(coSyncInfo: CoSyncInfo): void {
    this.syncInfoList.set(coSyncInfo.syncId, coSyncInfo);
  }

  getCoSyncInfo(syncId: number): CoSyncInfo | undefined {
    return this.syncInfoList.get(syncId);
  }

  setUserInfo(userInfo: CoFile.UserInfo): void {
    this.userInfo = userInfo;
  }

  getUserInfo(): CoFile.UserInfo {
    return this.userInfo;
  }

  getRootName(syncId: number): string {
    const info = this.getCoSyncInfo(syncId);
    if (!info) {
      return '';
    }
    return path.basename(info.config.syncPath.localPath);
  }

  getLocalRootPath(syncId: number): string {
    const info = this.getCoSyncInfo(syncId);
    if (!info) {
      return '';
    }
    return info.config.syncPath.localPath;
  }

  getLocalPathFromLocalRelatePath(syncId: number, relatePath: string): string {
    const info = this.getCoSyncInfo(syncId);
    if (!info) {
      return '';
    }

    let rootName = `${path.basename(info.config.syncPath.localPath)}`;
    rootName = path.join(rootName);
    const relativePath = relatePath.replace(rootName, '');
    const localPath = path.join(info.config.syncPath.localPath, relativePath);
    return localPath;
  }
}

const coSyncConfig = new CoSyncConfig();
export default coSyncConfig;
